import { render, staticRenderFns } from "./SchoolManage.vue?vue&type=template&id=31baeead&scoped=true"
import script from "./SchoolManage.vue?vue&type=script&lang=js"
export * from "./SchoolManage.vue?vue&type=script&lang=js"
import style0 from "./SchoolManage.vue?vue&type=style&index=0&id=31baeead&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "31baeead",
  null
  
)

export default component.exports